(function () {
  /**
   * @ngdoc module
   * @name binky.core.commerce
   */
  angular.module('binky.core.commerce', ['binky.core.lodash']);
})();
